/**
 * Empty function, used as a default value for callbacks or mocking purposes
 */

function noop() {}
export default noop;
//# sourceMappingURL=noop.js.map